/*
 * Smaakwijzer 2.0 / Bierpakket samenstellen — hoptimaal.com (17 okt 2026)
 * Eén finder voor beide pagina's: voor wie → smaakrichting(en) → hoe ver → hoeveel → een pakket van
 * bieren op voorraad. Per bier wisselen, vastzetten of weghalen; alles in één keer in de winkelwagen;
 * de adresbalk is het pakket (delen/verlanglijstje).
 * Richtingen = de groepen onder Biersoorten in het hoofdmenu (sections/hop-finder.liquid levert ze),
 * bieren = shop.metafields.custom.bierpakket (dagelijks, src/lib/hoptimaal/bierpakket.ts).
 * Rekenwerk is dat van de oude samensteller (assets/bierpakket.js), maar op fijne stijl en groep.
 * Bron: vat33/shopify-theme/hoptimaal/assets/finder.js
 */
(function () {
  "use strict";

  var root = document.getElementById("finder");
  if (!root) return;

  function leesJson(id, terug) {
    try {
      var e = document.getElementById(id);
      return e ? JSON.parse(e.textContent) || terug : terug;
    } catch (x) {
      return terug;
    }
  }
  var FEED = leesJson("fd-feed", null) || { st: [], br: [], us: [], b: [] };
  var REGELS = leesJson("fd-regels", {});
  var STIJLNAAM = leesJson("fd-stijlnamen", {});
  var GROEPEN = leesJson("fd-groepen", []); // [{ h, t, st: [stijlhandles], img: [urls], pakket: {…}|null }]
  var GEKOCHT = leesJson("fd-gekocht", null);
  var CTX = leesJson("fd-ctx", {});
  var I = leesJson("fd-i18n", {});
  (function () {
    var dec = document.createElement("textarea");
    for (var k in I) { dec.innerHTML = I[k]; I[k] = dec.value; }
  })();
  var TAAL = (document.documentElement.lang || "nl").slice(0, 2);
  var ROOT = (CTX.root || "/").replace(/\/$/, "");
  var MODUS = CTX.modus === "smaakwijzer" ? "smaakwijzer" : "bierpakket";
  // {{ n }} (themavertalingen) of [n] (teksten in de sectie: daar zou Liquid {{ }} zelf invullen)
  function vul(t, w) {
    return String(t || "")
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return w[k] != null ? w[k] : ""; })
      .replace(/\[(\w+)\]/g, function (m, k) { return w[k] != null ? w[k] : m; });
  }

  // ---------- smaak ----------
  // Assen: bitter, zoet, zuur, gebrand, fruitig, body (0–5)
  var W = [1, 1, 1.6, 1.2, 1, 0.7];
  var ASSEN = (I.assen || "Bitter|Zoet|Zuur|Geroosterd|Fruitig|Body").split("|");
  function afstand(a, b) {
    var s = 0;
    for (var i = 0; i < 6; i++) s += W[i] * (a[i] - b[i]) * (a[i] - b[i]);
    return s;
  }
  var GEEN_BIER = ["mede", "cider"];
  var VAT33 = "vat-33";
  var SOORTEN = {
    toegankelijk: { max: 450, niveau: 2 },
    mix: { max: 1200, parelElke: 3, niveau: 3 }, // elk derde bier mag een uitschieter zijn
    parels: { min: 450, max: 1500, niveau: 4 },
  };
  var AANTALLEN = [6, 12, 24];
  // Oude Smaakwijzer-profielen (links, deellinks, Klaviyo-segmenten) → richtingen
  var PROFIEL_NAAR = {
    "zacht-en-rond": ["belgisch"],
    "fris-en-fruitig": ["zuur-fruitig"],
    "hoppig-en-bitter": ["hoppig-bitter"],
    "donker-en-romig": ["donker-romig"],
    "zonder-alcohol": [],
  };
  var NAAR_PROFIEL = { "hoppig-bitter": "Hoppig & Bitter", "donker-romig": "Donker & Romig", belgisch: "Zacht & Rond", "zuur-fruitig": "Fris & Fruitig", "lager-duits": "Zacht & Rond" };

  // ---------- groepen en bieren ----------
  var GROEP = {}; // groephandle → groep
  var GROEP_VAN = {}; // stijlhandle → groephandle
  GROEPEN.forEach(function (g) {
    GROEP[g.h] = g;
    (g.st || []).forEach(function (s) { if (!GROEP_VAN[s]) GROEP_VAN[s] = g.h; });
  });

  var US = FEED.us || [];
  var BIEREN = (FEED.b || []).map(function (b) {
    var st = FEED.st[b[1]] || [];
    var fijn = b[12] != null && FEED.st[b[12]] ? FEED.st[b[12]][0] : st[0] || "";
    var br = (FEED.br || [])[b[7]] || [];
    return {
      h: b[0],
      st: st[0] || "",
      fijn: fijn,
      gr: GROEP_VAN[fijn] || GROEP_VAN[st[0]] || "",
      abv: b[2],
      s: String(b[3]).split("").map(Number),
      niv: b[4],
      prijs: b[5],
      vrd: b[6],
      br: br[0] || "",
      brNaam: br[1] || "",
      ml: b[8],
      r: b[9] / 100,
      id: b[10],
      regel: REGELS[b[0]] || b[11] || "",
      us: b[13] != null && b[13] >= 0 ? US[b[13]] || "" : "",
      nr: b[14] || 0,
    };
  });
  var OP_HANDLE = {};
  BIEREN.forEach(function (x) { OP_HANDLE[x.h] = x; });
  function isAlcoholarm(x) {
    // tot en met 0,5%: wettelijk alcoholvrij of alcoholarm, valt niet onder de Alcoholwet
    return (x.abv >= 0 && x.abv <= 5) || x.st === "alcoholvrij" || x.fijn === "alcoholvrij";
  }
  function isGewoon(x) {
    return x.vrd >= 2 && GEEN_BIER.indexOf(x.st) === -1 && !isAlcoholarm(x);
  }
  // Untappd-score met weinig ratings telt maar half mee (anders wint elk bier met 3 lovende check-ins)
  function score10(x) {
    if (!(x.r > 0)) return 0;
    var w = Math.min(1, (x.nr || 0) / 150);
    return x.r * (0.5 + w / 2) + 3.6 * (0.5 - w / 2);
  }

  // Wat elke richting nu op voorraad heeft: aantal, alcoholbereik, voorbeeldstijlen, smaak
  var GROEP_INFO = {};
  GROEPEN.forEach(function (g) {
    var lijst = BIEREN.filter(function (x) { return x.gr === g.h && isGewoon(x); });
    var abv = lijst.map(function (x) { return x.abv; }).filter(function (a) { return a > 0; }).sort(function (a, b) { return a - b; });
    var tel = {}, som = [0, 0, 0, 0, 0, 0];
    lijst.forEach(function (x) {
      tel[x.fijn] = (tel[x.fijn] || 0) + 1;
      for (var i = 0; i < 6; i++) som[i] += x.s[i];
    });
    var c = som.map(function (v) { return lijst.length ? v / lijst.length : 0; });
    var p = function (q) { return abv.length ? abv[Math.min(abv.length - 1, Math.floor(abv.length * q))] : 0; };
    GROEP_INFO[g.h] = {
      n: lijst.length,
      abv: [p(0.1), p(0.9)],
      stijlen: Object.keys(tel).sort(function (a, b) { return tel[b] - tel[a]; }),
      c: c,
    };
  });
  var RICHTINGEN = GROEPEN.filter(function (g) { return GROEP_INFO[g.h] && GROEP_INFO[g.h].n >= 6; }).map(function (g) { return g.h; });

  var gekochtIds = {};
  if (GEKOCHT && typeof GEKOCHT === "object") {
    Object.keys(GEKOCHT).forEach(function (k) {
      var m = String(k).match(/(\d+)$/);
      if (m) gekochtIds[m[1]] = 1;
    });
  }
  var heeftGekocht = Object.keys(gekochtIds).length > 0;

  // ---------- staat ----------
  var staat = {
    stap: "voor", // voor | richting | stijlen | soort | aantal | pakket
    voor: null, // mezelf | cadeau | samen
    modus: null, // richting | mix | zelf
    richtingen: [],
    alcvrij: false,
    stijlen: [],
    soort: null,
    aantal: null,
    nieuw: true,
    pakket: [], // [{ b, vast, p, geweigerd }]
    vorige: {},
    gemaild: null,
    gedeeld: false,
    vervangen: false,
    id: null,
    actief: 0, // bier dat in de carrousel in beeld is
  };

  // ---------- Klaviyo ----------
  function kl(event, props) {
    try {
      var k = window.klaviyo;
      if (!k) return;
      var p = Object.assign({ Taal: TAAL, Bron: MODUS, Voor: staat.voor || "", Smaak: smaakNaam(), Soort: staat.soort || "", Aantal: staat.pakket.length || staat.aantal || 0 }, props || {});
      if (typeof k.track === "function") k.track(event, p);
      else if (typeof k.push === "function") k.push(["track", event, p]);
    } catch (e) {}
  }
  function smaakNaam() {
    if (staat.modus === "zelf") return "Zelf: " + staat.stijlen.join(", ");
    if (staat.modus === "mix") return "Mix" + (staat.alcvrij ? " + alcoholvrij" : "");
    var n = staat.richtingen.map(function (h) { return h; });
    if (staat.alcvrij) n.push("alcoholvrij");
    return n.join(" + ");
  }
  function smaakLabel() {
    if (staat.modus === "zelf") return staat.stijlen.length <= 3 ? staat.stijlen.map(function (h) { return STIJLNAAM[h] || h; }).join(", ") : I.smaak_zelf;
    if (staat.modus === "mix") return I.o_verras + (staat.alcvrij ? " · " + I.o_alcvrij : "");
    var n = staat.richtingen.map(function (h) { return GROEP[h] ? GROEP[h].t : h; });
    if (staat.alcvrij) n.push(I.o_alcvrij);
    return n.join(" + ");
  }
  // Voor Klaviyo-segmenten van de oude Smaakwijzer
  function profielNaam() {
    if (staat.alcvrij && !staat.richtingen.length) return "Alcoholarm";
    return NAAR_PROFIEL[staat.richtingen[0]] || "";
  }

  // ---------- helpers ----------
  function el(tag, attrs, kinderen) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === "class") e.className = attrs[k];
      else if (k === "style") e.setAttribute("style", attrs[k]);
      else if (k.slice(0, 2) === "on") e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    }
    (kinderen || []).forEach(function (c) {
      if (c == null || c === false) return;
      e.appendChild(typeof c === "string" || typeof c === "number" ? document.createTextNode(String(c)) : c);
    });
    return e;
  }
  function komma(t) { return TAAL === "en" ? t : t.replace(".", ","); }
  function euro(cent) { return "€" + komma((cent / 100).toFixed(2)); }
  // Prijs zonder €-teken op de pagina (17 okt 2026, zoals Coolblue); euro() voor zinnen en mails
  function prijs(cent) { return komma((cent / 100).toFixed(2)); }
  function procent(abv10) { return komma((abv10 / 10).toFixed(1).replace(/\.0$/, "")); }
  function ster(r) { return "★ " + komma(r.toFixed(2)); }
  function aantalRatings(n) {
    if (!n) return "";
    if (n >= 1000) return komma((n / 1000).toFixed(n >= 10000 ? 0 : 1)) + "k";
    return String(n);
  }
  function naarBoven() {
    var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: "smooth" });
  }
  function voet() { return el("p", { class: "fd-voet" }, [I.voet]); }
  function svgKrat(n) {
    var k = n === 6 ? [3, 2] : n === 12 ? [4, 3] : [6, 4];
    var w = 120, h = 84, pad = 8, cw = (w - pad * 2) / k[0], ch = (h - pad * 2) / k[1], r = Math.min(cw, ch) * 0.36;
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 " + w + " " + h);
    svg.setAttribute("class", "fd-krat");
    svg.setAttribute("aria-hidden", "true");
    var rect = document.createElementNS(ns, "rect");
    rect.setAttribute("x", "2"); rect.setAttribute("y", "2"); rect.setAttribute("width", w - 4); rect.setAttribute("height", h - 4);
    rect.setAttribute("fill", "none"); rect.setAttribute("stroke", "currentColor"); rect.setAttribute("stroke-width", "3");
    svg.appendChild(rect);
    for (var i = 0; i < k[0]; i++) for (var j = 0; j < k[1]; j++) {
      var c = document.createElementNS(ns, "circle");
      c.setAttribute("cx", pad + cw * (i + 0.5)); c.setAttribute("cy", pad + ch * (j + 0.5)); c.setAttribute("r", r);
      c.setAttribute("fill", "currentColor");
      svg.appendChild(c);
    }
    return svg;
  }
  function smaakBalken(c, n) {
    var idx = [0, 1, 2, 3, 4, 5].sort(function (a, b) { return c[b] - c[a]; }).slice(0, n || 3);
    return el("div", { class: "fd-smaak" }, idx.map(function (i) {
      return el("div", { class: "fd-as" }, [
        el("span", {}, [ASSEN[i]]),
        el("i", { style: "--w:" + Math.round(Math.min(5, c[i]) * 20) + "%" }),
      ]);
    }));
  }

  // ---------- het rekenwerk ----------
  function magErin(x, band) {
    if (x.vrd < 2) return false; // net genoeg voorraad = kans op 'uitverkocht' bij afrekenen
    if (staat.modus === "zelf") {
      if (staat.stijlen.indexOf(x.fijn) === -1 && staat.stijlen.indexOf(x.st) === -1) return false;
    } else {
      if (GEEN_BIER.indexOf(x.st) !== -1) return false;
      if (staat.alcvrij) {
        if (!isAlcoholarm(x)) return false;
      } else {
        if (isAlcoholarm(x)) return false;
        if (staat.modus === "richting" && staat.richtingen.indexOf(x.gr) === -1) return false;
        if (staat.modus === "mix" && !x.gr) return false;
      }
    }
    if (band && band.minAbv && x.abv >= 0 && x.abv < band.minAbv && x.gr !== "zuur-fruitig") return false;
    if (band && band.min && x.prijs < band.min) return false;
    if (band && band.max && x.prijs > band.max) return false;
    if (staat.nieuw && staat.voor === "mezelf" && heeftGekocht && gekochtIds[x.id]) return false;
    return true;
  }

  // Doel per plek: richting (om de beurt), stijl (zelf kiezen) + prijsband
  function plekDoel(i) {
    var soort = SOORTEN[staat.soort] || SOORTEN.mix;
    var band = { min: soort.min || 0, max: soort.max };
    if (soort.parelElke) band = i % soort.parelElke === soort.parelElke - 1 ? { min: 450, max: 1500 } : { min: 0, max: 600 };
    if (staat.soort === "parels" && !staat.alcvrij) band.minAbv = 60; // zwaargewichten: vanaf 6%
    if (staat.modus === "zelf") return { stijl: staat.stijlen[i % staat.stijlen.length], band: band };
    var lijst = staat.modus === "mix" ? RICHTINGEN : staat.richtingen;
    var g = lijst.length ? lijst[i % lijst.length] : null;
    // Alcoholvrij + richting: geen alcoholvrije IPA-groep, dus sturen op de smaak van die richting
    var c = staat.alcvrij && g && GROEP_INFO[g] ? GROEP_INFO[g].c : null;
    return { groep: staat.alcvrij ? null : g, c: c, band: band };
  }

  function score(x, doel) {
    var s = 0;
    if (doel.groep && x.gr !== doel.groep) s += 25; // andere gekozen richting mag, maar liever die van deze plek
    if (doel.c) s += afstand(doel.c, x.s) * 1.5;
    if (doel.stijl && x.fijn !== doel.stijl && x.st !== doel.stijl) s += 40;
    var soort = SOORTEN[staat.soort] || SOORTEN.mix;
    var niveau = soort.niveau;
    if (staat.voor !== "mezelf" && niveau > 3) niveau = 3; // cadeau/samen: bijzonder, maar niet alleen het zwaarste werk
    if (x.niv > niveau) s += (x.niv - niveau) * 6;
    var r = score10(x);
    if (staat.soort === "parels") {
      // zwaargewichten: echt bijzonder werk, geen sessiebier dat toevallig €4,50 kost
      if (x.niv <= 1) s += 6;
      if (x.abv >= 0 && x.abv < 60 && x.gr !== "zuur-fruitig") s += 14;
      s += r > 0 ? (3.9 - r) * 22 : 8;
    } else {
      s += r > 0 ? (3.8 - r) * 10 : 3;
    }
    if (x.br === VAT33) s -= 3; // onze eigen bieren krijgen wat extra liefde
    if (staat.vorige[x.h]) s += 10; // 'opnieuw samenstellen' moet ook echt iets nieuws geven
    return s + Math.random() * 6;
  }

  function aantalStijlen() {
    var gezien = {}, n = 0;
    BIEREN.forEach(function (x) {
      if (gezien[x.fijn] || !magErin(x, null)) return;
      gezien[x.fijn] = 1;
      n++;
    });
    return Math.max(1, n);
  }
  function grenzen(n) {
    var stijl = 99;
    var ns = aantalStijlen();
    if (staat.voor === "samen") stijl = Math.max(1, Math.ceil(n / ns));
    else if (staat.modus === "mix") stijl = n <= 6 ? 1 : n <= 12 ? 2 : 3;
    else if (staat.modus === "richting") stijl = Math.max(2, Math.ceil((n * 1.5) / ns));
    return { brouwerij: n >= 24 ? 2 : 1, vat33: n >= 24 ? 2 : 1, stijl: stijl };
  }

  // Beste bier voor plek i naast de rest van het pakket; lukt dat niet, stap voor stap ruimer:
  // 0 = streng · 1 = meer per brouwerij/stijl · 2 = ook buiten de prijsband
  function kiesVoorPlek(i, pakket, uitsluiten, n) {
    for (var r = 0; r <= 2; r++) {
      var b = zoek(i, pakket, uitsluiten, n, r);
      if (b) return b;
    }
    return null;
  }
  function zoek(i, pakket, uitsluiten, n, ruimte) {
    var doel = plekDoel(i);
    var g = grenzen(n);
    if (ruimte >= 1) { g.brouwerij += 1; g.stijl += 2; }
    if (ruimte >= 2) doel.band = { min: 0, max: staat.soort === "toegankelijk" ? 600 : 1500 };
    var inPakket = {}, perBr = {}, perSt = {}, vat = 0;
    pakket.forEach(function (p, j) {
      if (!p || j === i) return;
      inPakket[p.b.h] = 1;
      perBr[p.b.br] = (perBr[p.b.br] || 0) + 1;
      perSt[p.b.fijn] = (perSt[p.b.fijn] || 0) + 1;
      if (p.b.br === VAT33) vat++;
    });
    var beste = null, min = Infinity;
    for (var k = 0; k < BIEREN.length; k++) {
      var x = BIEREN[k];
      if (inPakket[x.h] || (uitsluiten && uitsluiten[x.h])) continue;
      if (!magErin(x, doel.band)) continue;
      if (x.br && (perBr[x.br] || 0) >= g.brouwerij) continue;
      if ((perSt[x.fijn] || 0) >= g.stijl) continue;
      if (x.br === VAT33 && vat >= g.vat33) continue;
      var sc = score(x, doel);
      if (sc < min) { min = sc; beste = x; }
    }
    return beste;
  }

  function stelSamen(n) {
    var pakket = [];
    staat.pakket.forEach(function (p) { if (p.vast) pakket.push({ b: p.b, vast: true, p: p.p, geweigerd: {} }); });
    for (var i = pakket.length; i < n; i++) {
      var b = kiesVoorPlek(i, pakket, null, n);
      if (!b) break;
      pakket.push({ b: b, vast: false, p: null, geweigerd: {} });
    }
    return sorteer(pakket);
  }
  // drinkvolgorde: van licht naar stevig
  function sorteer(pakket) {
    return pakket.sort(function (a, c) { return a.b.abv - c.b.abv || a.b.niv - c.b.niv; });
  }

  function schatting(n) {
    var bewaar = staat.pakket, som = 0, telling = 0;
    staat.pakket = [];
    for (var t = 0; t < 3; t++) {
      var p = stelSamen(n);
      som += p.reduce(function (s, x) { return s + x.b.prijs; }, 0);
      telling = Math.max(telling, p.length);
    }
    staat.pakket = bewaar;
    return { bedrag: Math.round(som / 3 / 50) * 50, n: telling };
  }

  // Hoeveel bieren passen bij een niveau (voor de cijfers bij 'hoe ver wil je gaan')
  function poolInfo(soortKey) {
    var soort = SOORTEN[soortKey];
    var band = { min: soort.min || 0, max: soortKey === "mix" ? 1500 : soort.max, minAbv: soortKey === "parels" && !staat.alcvrij ? 60 : 0 };
    var n = 0, rs = 0, rn = 0;
    BIEREN.forEach(function (x) {
      if (!magErin(x, band)) return;
      n++;
      if (x.r > 0) { rs += x.r; rn++; }
    });
    return { n: n, r: rn ? rs / rn : 0 };
  }

  // ---------- productdata ----------
  var CACHE = {};
  function haalProduct(handle) {
    if (CACHE[handle]) return CACHE[handle];
    CACHE[handle] = fetch(ROOT + "/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return CACHE[handle];
  }
  function variant(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }
  function laadProducten(pogingen) {
    pogingen = pogingen || 0;
    return Promise.all(staat.pakket.map(function (p) { return p.p ? p.p : haalProduct(p.b.h); })).then(function (lijst) {
      var opnieuw = false;
      lijst.forEach(function (prod, i) {
        var plek = staat.pakket[i];
        if (prod && variant(prod) && prod.featured_image) { plek.p = prod; return; }
        BIEREN = BIEREN.filter(function (x) { return x.h !== plek.b.h; });
        var nieuw = kiesVoorPlek(i, staat.pakket, plek.geweigerd, staat.pakket.length);
        if (nieuw) { staat.pakket[i] = { b: nieuw, vast: false, p: null, geweigerd: plek.geweigerd }; opnieuw = true; }
        else staat.pakket[i] = null;
      });
      staat.pakket = staat.pakket.filter(Boolean);
      if (opnieuw && pogingen < 3) return laadProducten(pogingen + 1);
    });
  }

  // Alles wat de mail "Je pakket staat nog klaar" nodig heeft (Klaviyo-sjabloon Viqe42)
  function pakketEvent() {
    var som = totaal();
    return {
      Aantal: staat.pakket.length,
      SmaakLabel: smaakLabel(),
      Totaal: euro(som),
      TotaalBedrag: som / 100,
      NogVoorGratis: CTX.gratis && som < CTX.gratis ? euro(CTX.gratis - som) : "",
      GratisBereikt: !!(CTX.gratis && som >= CTX.gratis),
      Link: pakketUrl(),
      Pakket: staat.id,
      Bieren: staat.pakket.map(function (p) {
        var prod = p.p || {};
        var v = variant(p.p);
        var beeld = prod.featured_image || "";
        if (beeld.slice(0, 2) === "//") beeld = "https:" + beeld;
        return {
          handle: p.b.h,
          titel: prod.title || p.b.h,
          beeld: beeld ? beeld + (beeld.indexOf("?") > -1 ? "&" : "?") + "width=200" : "",
          stijl: STIJLNAAM[p.b.fijn] || STIJLNAAM[p.b.st] || "",
          regel: p.b.regel || "",
          prijs: prijs(v ? v.price : p.b.prijs),
          url: window.location.origin + ROOT + "/products/" + p.b.h,
        };
      }),
    };
  }
  var updateTimer = null;
  function meldPakketLater() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () { kl("Bierpakket Samengesteld", pakketEvent()); }, 45000);
  }
  function totaal() {
    return staat.pakket.reduce(function (s, p) {
      var v = variant(p.p);
      return s + (v ? v.price : p.b.prijs);
    }, 0);
  }

  // ---------- deellink: de adresbalk ís het pakket ----------
  function pakketUrl() {
    var u = new URL(window.location.href);
    ["smaak", "voor", "richting"].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set("p", staat.pakket.map(function (p) { return p.b.h; }).join("."));
    u.searchParams.set("k", [
      staat.voor === "cadeau" ? "c" : staat.voor === "samen" ? "s" : "m",
      staat.modus === "zelf" ? "zelf" : staat.modus === "mix" ? "mix" : "r",
      staat.soort || "",
      staat.stijlen.join("+"),
      staat.richtingen.join("+"),
      staat.alcvrij ? "a" : "",
    ].join("~"));
    return u.toString();
  }
  function bewaarInUrl() {
    try { window.history.replaceState(null, "", pakketUrl()); } catch (e) {}
  }
  function zetKeuzes(k) {
    staat.voor = k[0] === "c" ? "cadeau" : k[0] === "s" ? "samen" : "mezelf";
    staat.soort = SOORTEN[k[2]] ? k[2] : "mix";
    staat.stijlen = (k[3] || "").split("+").filter(Boolean);
    staat.richtingen = (k[4] || "").split("+").filter(function (h) { return GROEP[h]; });
    staat.alcvrij = k[5] === "a";
    if (k[1] === "zelf" && staat.stijlen.length) staat.modus = "zelf";
    else if (PROFIEL_NAAR[k[1]]) {
      // deellink van vóór 17 okt 2026 (smaakprofiel)
      staat.richtingen = PROFIEL_NAAR[k[1]].slice();
      staat.alcvrij = k[1] === "zonder-alcohol";
      staat.modus = staat.richtingen.length ? "richting" : "mix";
    } else if (k[1] === "r" && (staat.richtingen.length || staat.alcvrij)) staat.modus = "richting";
    else staat.modus = "mix";
  }
  function leesUitUrl() {
    var q = new URLSearchParams(window.location.search);
    var p = q.get("p");
    if (!p) return false;
    zetKeuzes((q.get("k") || "").split("~"));
    staat.nieuw = false; // een gedeeld pakket laten we zoals het is
    var handles = p.split(".").filter(Boolean).slice(0, 48);
    staat.pakket = handles.map(function (h) { return OP_HANDLE[h] ? { b: OP_HANDLE[h], vast: true, p: null, geweigerd: {} } : null; });
    var missend = staat.pakket.filter(function (x) { return !x; }).length;
    staat.pakket = staat.pakket.filter(Boolean);
    staat.aantal = handles.length;
    if (missend) {
      staat.vervangen = true;
      staat.pakket = stelSamen(handles.length);
    }
    staat.pakket.forEach(function (x) { x.vast = false; });
    staat.gedeeld = true;
    staat.id = "BP-DEEL-" + Date.now().toString(36).toUpperCase();
    staat.stap = "pakket";
    return true;
  }

  // ---------- schermen ----------
  var TOTAAL_STAPPEN = 4;
  function render() {
    root.innerHTML = "";
    if (zweef && staat.stap !== "pakket") zweef.classList.remove("is-aan");
    root.classList.toggle("fd--pakket", staat.stap === "pakket");
    if (staat.stap === "voor") return renderVoor();
    if (staat.stap === "richting") return renderRichting();
    if (staat.stap === "stijlen") return renderStijlen();
    if (staat.stap === "soort") return renderSoort();
    if (staat.stap === "aantal") return renderAantal();
    return renderPakket();
  }
  function ga(stap) {
    staat.stap = stap;
    render();
    naarBoven();
  }

  function balk(n, terugNaar) {
    return el("div", { class: "fd-balk" }, [
      terugNaar ? el("button", { type: "button", class: "fd-terug", "aria-label": I.vorige, onclick: function () { ga(terugNaar); } }, ["←"]) : el("span", { class: "fd-terug fd-terug--leeg" }),
      el("div", { class: "fd-voortgang", role: "progressbar", "aria-valuemin": "0", "aria-valuemax": String(TOTAAL_STAPPEN), "aria-valuenow": String(n) }, [
        el("span", { style: "width:" + Math.round((n / TOTAAL_STAPPEN) * 100) + "%" }),
      ]),
      el("span", { class: "fd-teller" }, [vul(I.stap, { n: n, totaal: TOTAAL_STAPPEN })]),
    ]);
  }
  function keuze(o, klik, gekozen) {
    return el("button", { type: "button", class: "fd-keuze" + (gekozen ? " is-gekozen" : "") + (o.extra ? " " + o.extra : ""), "aria-pressed": o.toggle ? (gekozen ? "true" : "false") : null, onclick: klik }, [
      o.badge ? el("span", { class: "fd-badge" }, [o.badge]) : null,
      o.svg || null,
      el("span", { class: "fd-keuze__t" }, [o.t]),
      o.sub ? el("span", { class: "fd-keuze__sub" }, [o.sub]) : null,
      o.info ? el("span", { class: "fd-keuze__info" }, [o.info]) : null,
    ]);
  }

  function renderVoor() {
    // één blik uit elke richting (eerste beeld), dan de tweede ronde: zo staat elke smaak in de rij
    var blikken = [];
    for (var r = 0; r < 3 && blikken.length < 5; r++) GROEPEN.forEach(function (g) { if (g.img && g.img[r] && blikken.length < 5) blikken.push(g.img[r]); });
    var kop = el("div", { class: "fd-kop fd-kop--start" }, [
      el("div", {}, [
        el("p", { class: "fd-kicker" }, [MODUS === "smaakwijzer" ? I.kicker_sw : I.kicker_bp]),
        el("h1", { class: "fd-titel" }, [MODUS === "smaakwijzer" ? I.titel_sw : I.titel_bp]),
        el("p", { class: "fd-intro" }, [I.intro]),
        el("ul", { class: "fd-usp" }, String(I.usp || "").split("|").filter(Boolean).map(function (t) { return el("li", {}, [t]); })),
      ]),
      blikken.length ? el("div", { class: "fd-blikken", "aria-hidden": "true" }, blikken.map(function (u) { return el("img", { src: u, alt: "", width: "90", height: "150" }); })) : null,
    ]);
    root.appendChild(el("div", { class: "fd-stap" }, [
      kop,
      balk(1, null),
      el("h2", { class: "fd-vraag" }, [I.v_voor]),
      el("div", { class: "fd-keuzes fd-keuzes--3" }, [
        keuze({ t: I.o_mezelf, sub: I.o_mezelf_sub }, function () { begin("mezelf"); }, staat.voor === "mezelf"),
        keuze({ t: I.o_cadeau, sub: I.o_cadeau_sub }, function () { begin("cadeau"); }, staat.voor === "cadeau"),
        keuze({ t: I.o_samen, sub: I.o_samen_sub }, function () { begin("samen"); }, staat.voor === "samen"),
      ]),
      voet(),
    ]));
  }
  var gestart = false;
  function begin(voor) {
    staat.voor = voor;
    if (!gestart) kl("Bierpakket Gestart");
    gestart = true;
    ga("richting");
  }

  function renderRichting() {
    var verder = el("button", { type: "button", class: "fd-knop", onclick: function () { if (klaar()) ga("soort"); } }, [I.verder]);
    var status = el("span", { class: "fd-status" });
    function klaar() { return staat.modus === "mix" || staat.richtingen.length > 0 || staat.alcvrij; }
    function bijwerken() {
      verder.disabled = !klaar();
      status.textContent = staat.modus === "mix" ? I.o_verras : staat.richtingen.length || staat.alcvrij ? smaakLabel() : I.kies_iets;
      kaarten.forEach(function (k) {
        var aan = k.h === "mix" ? staat.modus === "mix" : k.h === "alcvrij" ? staat.alcvrij : staat.modus === "richting" && staat.richtingen.indexOf(k.h) !== -1;
        k.knop.classList.toggle("is-gekozen", aan);
        k.knop.setAttribute("aria-pressed", aan ? "true" : "false");
      });
    }
    var kaarten = RICHTINGEN.map(function (h) {
      var g = GROEP[h], info = GROEP_INFO[h];
      var knop = el("button", { type: "button", class: "fd-richting", "aria-pressed": "false" }, [
        el("span", { class: "fd-richting__beeld" }, (g.img || []).slice(0, 3).map(function (u) { return el("img", { src: u, alt: "", loading: "lazy", width: "90", height: "120" }); })),
        el("span", { class: "fd-richting__vink", "aria-hidden": "true" }, ["✓"]),
        el("span", { class: "fd-richting__body" }, [
          el("span", { class: "fd-richting__kop" }, [
            el("span", { class: "fd-richting__t" }, [g.t]),
            info.abv[1] ? el("span", { class: "fd-richting__abv" }, [procent(info.abv[0]) + "–" + procent(info.abv[1]) + "%"]) : null,
          ]),
          el("span", { class: "fd-richting__stijlen" }, [info.stijlen.slice(0, 4).map(function (s) { return STIJLNAAM[s] || s; }).join(", ")]),
          smaakBalken(info.c, 3),
          el("span", { class: "fd-richting__n" }, [vul(I.op_voorraad, { n: info.n })]),
        ]),
      ]);
      knop.addEventListener("click", function () {
        if (staat.modus !== "richting") { staat.modus = "richting"; }
        var i = staat.richtingen.indexOf(h);
        if (i === -1) staat.richtingen.push(h);
        else staat.richtingen.splice(i, 1);
        bijwerken();
      });
      return { h: h, knop: knop };
    });
    var alcN = BIEREN.filter(function (x) { return x.vrd >= 2 && isAlcoholarm(x); }).length;
    var alc = el("button", { type: "button", class: "fd-richting fd-richting--klein", "aria-pressed": "false" }, [
      el("span", { class: "fd-richting__vink", "aria-hidden": "true" }, ["✓"]),
      el("span", { class: "fd-richting__body" }, [
        el("span", { class: "fd-richting__kop" }, [el("span", { class: "fd-richting__t" }, [I.o_alcvrij]), el("span", { class: "fd-richting__abv" }, ["0–0,5%"])]),
        el("span", { class: "fd-richting__stijlen" }, [I.o_alcvrij_sub]),
        el("span", { class: "fd-richting__n" }, [vul(I.op_voorraad, { n: alcN })]),
      ]),
    ]);
    alc.addEventListener("click", function () {
      staat.alcvrij = !staat.alcvrij;
      if (staat.modus === "zelf" || !staat.modus) staat.modus = "richting";
      bijwerken();
    });
    var mix = el("button", { type: "button", class: "fd-richting fd-richting--klein", "aria-pressed": "false" }, [
      el("span", { class: "fd-richting__vink", "aria-hidden": "true" }, ["✓"]),
      el("span", { class: "fd-richting__body" }, [
        el("span", { class: "fd-richting__kop" }, [el("span", { class: "fd-richting__t" }, [I.o_verras])]),
        el("span", { class: "fd-richting__stijlen" }, [I.o_verras_sub]),
      ]),
    ]);
    mix.addEventListener("click", function () {
      if (staat.modus === "mix") { staat.modus = null; }
      else { staat.modus = "mix"; staat.richtingen = []; }
      bijwerken();
    });
    kaarten.push({ h: "alcvrij", knop: alc }, { h: "mix", knop: mix });

    var vraag = staat.voor === "cadeau" ? I.v_richting_c : staat.voor === "samen" ? I.v_richting_s : I.v_richting;
    root.appendChild(el("div", { class: "fd-stap" }, [
      balk(2, "voor"),
      el("h2", { class: "fd-vraag" }, [vraag]),
      el("p", { class: "fd-hulp" }, [I.richting_hulp]),
      el("div", { class: "fd-richtingen" }, kaarten.slice(0, RICHTINGEN.length).map(function (k) { return k.knop; })),
      el("div", { class: "fd-richtingen fd-richtingen--extra" }, [alc, mix,
        el("button", { type: "button", class: "fd-richting fd-richting--klein fd-richting--link", onclick: function () { staat.modus = "zelf"; ga("stijlen"); } }, [
          el("span", { class: "fd-richting__body" }, [
            el("span", { class: "fd-richting__kop" }, [el("span", { class: "fd-richting__t" }, [I.o_zelf])]),
            el("span", { class: "fd-richting__stijlen" }, [I.o_zelf_sub]),
          ]),
        ]),
      ]),
      el("div", { class: "fd-verder" }, [status, verder]),
    ]));
    if (staat.modus === "zelf") staat.modus = staat.richtingen.length || staat.alcvrij ? "richting" : null;
    bijwerken();
  }

  function renderStijlen() {
    var tel = {};
    BIEREN.forEach(function (x) { if (x.vrd >= 2 && GEEN_BIER.indexOf(x.st) === -1) tel[x.fijn] = (tel[x.fijn] || 0) + 1; });
    var verder = el("button", { type: "button", class: "fd-knop", disabled: !staat.stijlen.length, onclick: function () { ga("soort"); } }, [I.verder]);
    // per richting gegroepeerd, zoals in het menu; de rest onder 'Meer'
    var blokken = [];
    var gehad = {};
    GROEPEN.concat([{ h: "_rest", t: I.meer_stijlen, st: Object.keys(tel) }]).forEach(function (g) {
      var stijlen = (g.st || []).filter(function (h) { return tel[h] >= 2 && !gehad[h]; });
      if (!stijlen.length) return;
      stijlen.forEach(function (h) { gehad[h] = 1; });
      blokken.push(el("div", { class: "fd-stijlblok" }, [
        el("h3", { class: "fd-stijlblok__t" }, [g.t]),
        el("div", { class: "fd-chips" }, stijlen.map(function (h) {
          var aan = staat.stijlen.indexOf(h) !== -1;
          var knop = el("button", { type: "button", class: "fd-chip" + (aan ? " is-gekozen" : ""), "aria-pressed": aan ? "true" : "false" }, [STIJLNAAM[h] || h, el("span", {}, [String(tel[h])])]);
          knop.addEventListener("click", function () {
            var i = staat.stijlen.indexOf(h);
            if (i === -1) staat.stijlen.push(h);
            else staat.stijlen.splice(i, 1);
            knop.classList.toggle("is-gekozen", i === -1);
            knop.setAttribute("aria-pressed", i === -1 ? "true" : "false");
            verder.disabled = !staat.stijlen.length;
          });
          return knop;
        })),
      ]));
    });
    root.appendChild(el("div", { class: "fd-stap" }, [
      balk(2, "richting"),
      el("h2", { class: "fd-vraag" }, [I.v_stijlen]),
      el("p", { class: "fd-hulp" }, [I.stijlen_hulp]),
      el("div", { class: "fd-stijlblokken" }, blokken),
      el("div", { class: "fd-verder" }, [el("span", { class: "fd-status" }), verder]),
    ]));
  }

  function renderSoort() {
    var opties = [
      { k: "toegankelijk", t: I.o_door, sub: I.o_door_sub },
      { k: "mix", t: I.o_mix, sub: I.o_mix_sub },
      { k: "parels", t: I.o_zwaar, sub: I.o_zwaar_sub },
    ];
    root.appendChild(el("div", { class: "fd-stap" }, [
      balk(3, staat.modus === "zelf" ? "stijlen" : "richting"),
      el("h2", { class: "fd-vraag" }, [I.v_niveau]),
      el("p", { class: "fd-hulp" }, [smaakLabel()]),
      el("div", { class: "fd-keuzes fd-keuzes--3" }, opties.map(function (o) {
        var pi = poolInfo(o.k);
        return keuze(
          { t: o.t, sub: o.sub, info: pi.n ? vul(I.niveau_info, { n: pi.n, r: pi.r ? komma(pi.r.toFixed(2)) : "–" }) : I.niveau_leeg, extra: pi.n ? "" : "is-leeg" },
          function () { staat.soort = o.k; ga("aantal"); },
          staat.soort === o.k
        );
      })),
    ]));
  }

  function renderAantal() {
    var opties = AANTALLEN.map(function (n) {
      var sch = schatting(n);
      var gratis = CTX.gratis && sch.bedrag >= CTX.gratis;
      return keuze(
        { t: vul(I.o_aantal, { n: n }), sub: sch.n < n ? vul(I.maar_n, { n: sch.n }) : vul(I.schatting, { bedrag: prijs(sch.bedrag) }), svg: svgKrat(n), badge: gratis ? I.gratis_verzending : null, extra: "fd-keuze--aantal" + (sch.n < n ? " is-leeg" : "") },
        function () { staat.aantal = n; maakPakket(); },
        staat.aantal === n
      );
    });
    root.appendChild(el("div", { class: "fd-stap" }, [
      balk(4, "soort"),
      el("h2", { class: "fd-vraag" }, [I.v_aantal]),
      el("div", { class: "fd-keuzes fd-keuzes--3" }, opties),
    ]));
  }

  // Wachtzinnen (MisterHop-achtig, maar dan van ons)
  function laadScherm() {
    var zinnen = String(I.laden || "").split("|").filter(Boolean);
    var p = el("p", { class: "fd-laden" }, [zinnen[0] || ""]);
    var i = 0;
    var t = setInterval(function () {
      if (!p.isConnected) return clearInterval(t);
      i = (i + 1) % zinnen.length;
      p.textContent = zinnen[i];
    }, 700);
    root.innerHTML = "";
    root.appendChild(el("div", { class: "fd-laadvak" }, [el("span", { class: "fd-spinner", "aria-hidden": "true" }), p]));
  }

  function maakPakket() {
    staat.vorige = {};
    staat.gemaild = null;
    staat.gedeeld = false;
    staat.vervangen = false;
    staat.pakket = stelSamen(staat.aantal);
    staat.actief = 0;
    staat.id = "BP-" + Date.now().toString(36).toUpperCase();
    staat.stap = "pakket";
    laadScherm();
    naarBoven();
    var minstens = new Promise(function (r) { setTimeout(r, 1400); }); // even de tijd om de zinnen te lezen
    Promise.all([laadProducten(), minstens]).then(function () {
      sorteer(staat.pakket); // wat bij het laden vervangen is, schuift op zijn plek
      render();
      bewaarInUrl();
      kl("Bierpakket Samengesteld", pakketEvent());
    });
  }

  function renderPakket() {
    var n = staat.pakket.length;
    if (staat.actief >= n) staat.actief = Math.max(0, n - 1);
    var brs = {}, sts = {}, rs = 0, rn = 0;
    staat.pakket.forEach(function (p) {
      if (p.b.br) brs[p.b.br] = 1;
      sts[p.b.fijn] = 1;
      if (p.b.r > 0) { rs += p.b.r; rn++; }
    });
    var kicker = staat.gedeeld ? I.gedeeld : staat.voor === "cadeau" ? I.pakket_ontvanger : staat.voor === "samen" ? I.pakket_samen : I.jouw_pakket;
    var kop = el("div", { class: "fd-pkop" }, [
      el("p", { class: "fd-kicker" }, [kicker]),
      el("h2", { class: "fd-titel fd-titel--pakket" }, [smaakLabel()]),
      el("ul", { class: "fd-stats" }, [
        el("li", {}, [vul(I.resultaat_titel, { n: n })]),
        el("li", {}, [vul(I.stat_brouwerijen, { n: Object.keys(brs).length })]),
        el("li", {}, [vul(I.stat_stijlen, { n: Object.keys(sts).length })]),
        rn ? el("li", {}, [vul(I.stat_score, { r: komma((rs / rn).toFixed(2)) })]) : null,
      ]),
      staat.gedeeld ? el("p", { class: "fd-intro" }, [I.gedeeld_intro]) : null,
      staat.vervangen ? el("p", { class: "fd-melding" }, [I.vervangen]) : null,
      n < (staat.aantal || 0) && !staat.gedeeld ? el("p", { class: "fd-melding" }, [I.te_weinig]) : null,
    ]);

    var opties = null;
    if (CTX.klant && heeftGekocht && staat.voor === "mezelf") {
      var vink = el("input", { type: "checkbox", checked: staat.nieuw });
      vink.addEventListener("change", function () {
        staat.nieuw = vink.checked;
        opnieuwSamenstellen();
      });
      opties = el("label", { class: "fd-vinkje" }, [vink, el("span", {}, [I.nieuw_voor_jou])]);
    }

    var zijkant = el("aside", { class: "fd-zij" }, [
      afrekenBalk(),
      el("div", { class: "fd-zij__links" }, [
        el("button", { type: "button", class: "fd-link", onclick: bierErbij }, ["+ " + I.toevoegen]),
        el("button", { type: "button", class: "fd-link", onclick: opnieuwSamenstellen }, ["↻ " + I.opnieuw]),
        el("button", { type: "button", class: "fd-link", onclick: function () { staat.pakket = []; staat.actief = 0; ga("richting"); } }, ["← " + I.andere_keuzes]),
      ]),
      staat.voor === "cadeau" && !staat.gedeeld ? el("p", { class: "fd-hulp" }, [I.delen_cadeau]) : null,
    ]);

    root.appendChild(el("div", { class: "fd-pakket" }, [
      kop,
      opties,
      el("div", { class: "fd-res" }, [carrousel(), zijkant]),
      vasteBox(),
      mailMij(),
      voet(),
    ]));
    startCarrousel();
    zweefBalk();
  }

  // ---------- carrousel: strip met alle blikken + één groot bier tegelijk (swipen/pijltjes) ----------
  function beeldUrl(prod, w) {
    var u = prod && prod.featured_image;
    if (!u) return null;
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  // Eerste alinea's van de productbeschrijving (NL/EN/DE: de .js-feed volgt de taal van de winkel)
  var OVER = {};
  function overDitBier(p) {
    if (OVER[p.b.h] != null) return OVER[p.b.h];
    var tekst = "";
    try {
      var d = new DOMParser().parseFromString((p.p && p.p.description) || "", "text/html");
      var delen = [];
      d.querySelectorAll("p").forEach(function (x) {
        var s = (x.textContent || "").replace(/\s+/g, " ").trim();
        if (s.length > 40 && delen.join(" ").length < 380) delen.push(s);
      });
      if (!delen.length) delen.push((d.body.textContent || "").replace(/\s+/g, " ").trim());
      tekst = delen.join(" ");
      if (tekst.length > 460) {
        var knip = tekst.slice(0, 460);
        var punt = Math.max(knip.lastIndexOf(". "), knip.lastIndexOf("! "), knip.lastIndexOf("? "));
        tekst = punt > 200 ? knip.slice(0, punt + 1) : knip.replace(/\s+\S*$/, "") + " …";
      }
    } catch (e) {}
    OVER[p.b.h] = tekst;
    return tekst;
  }
  function productUrl(p) {
    var prod = p.p || {};
    return prod.url ? ROOT + prod.url.replace(/^\/(en|de|nl)(?=\/)/, "") : ROOT + "/products/" + p.b.h;
  }

  function carrousel() {
    var n = staat.pakket.length;
    var rail = el("div", { class: "fd-rail", role: "tablist", "aria-label": I.jouw_pakket }, staat.pakket.map(function (p, i) {
      var b = beeldUrl(p.p, 160);
      return el("button", { type: "button", class: "fd-rail__item" + (i === staat.actief ? " is-actief" : ""), role: "tab", "aria-label": (i + 1) + ". " + ((p.p && p.p.title) || p.b.h), onclick: function () { naarBier(i, true); } }, [
        b ? el("img", { src: b, alt: "", width: "50", height: "66" }) : null,
        el("span", {}, [String(i + 1)]),
      ]);
    }));
    var slides = el("div", { class: "fd-slides", tabindex: "0", "aria-roledescription": "carrousel" }, staat.pakket.map(function (p, i) { return slide(p, i, n); }));
    slides.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { naarBier(staat.actief + 1, true); e.preventDefault(); }
      if (e.key === "ArrowLeft") { naarBier(staat.actief - 1, true); e.preventDefault(); }
    });
    return el("div", { class: "fd-car" }, [
      rail,
      el("div", { class: "fd-car__vak" }, [
        el("button", { type: "button", class: "fd-car__pijl fd-car__pijl--l", "aria-label": I.vorig_bier, onclick: function () { naarBier(staat.actief - 1, true); } }, ["←"]),
        slides,
        el("button", { type: "button", class: "fd-car__pijl fd-car__pijl--r", "aria-label": I.volgend_bier, onclick: function () { naarBier(staat.actief + 1, true); } }, ["→"]),
      ]),
    ]);
  }

  function slide(p, i, n) {
    var prod = p.p || {};
    var v = variant(p.p);
    var titel = prod.title || p.b.h;
    var url = productUrl(p);
    var beeld = beeldUrl(prod, 700);
    var stijlH = STIJLNAAM[p.b.fijn] ? p.b.fijn : p.b.st;
    var stijl = p.b.us || STIJLNAAM[stijlH] || "";
    var feiten = [];
    if (p.b.abv >= 0) feiten.push(procent(p.b.abv) + "%");
    if (p.b.ml > 0) feiten.push(p.b.ml + " ml");
    var over = overDitBier(p);
    var smaken = String(p.b.regel || "").split(/\s*,\s*/).filter(Boolean).slice(0, 5);
    return el("article", { class: "fd-slide", "aria-label": (i + 1) + " / " + n }, [
      el("a", { class: "fd-slide__beeld", href: url, tabindex: "-1" }, [
        beeld ? el("img", { src: beeld, alt: titel, loading: i < 2 ? "eager" : "lazy" }) : null,
        el("span", { class: "fd-slide__nr" }, [(i + 1) + " / " + n]),
      ]),
      el("div", { class: "fd-slide__info" }, [
        stijl ? (STIJLNAAM[stijlH] ? el("a", { class: "fd-slide__stijl", href: CTX.bierschool + stijlH, title: vul(I.stijl_link_titel, { stijl: STIJLNAAM[stijlH] }) }, [stijl]) : el("p", { class: "fd-slide__stijl" }, [stijl])) : null,
        el("h3", { class: "fd-slide__titel" }, [el("a", { href: url }, [titel])]),
        p.b.brNaam ? el("p", { class: "fd-slide__brouwer" }, [p.b.brNaam]) : null,
        el("div", { class: "fd-slide__feiten" }, [
          p.b.r > 0 ? el("span", { class: "fd-slide__score" }, [ster(p.b.r), p.b.nr ? el("small", {}, [" (" + aantalRatings(p.b.nr) + ")"]) : null]) : null,
          feiten.length ? el("span", {}, [feiten.join(" · ")]) : null,
        ]),
        smaken.length ? el("ul", { class: "fd-slide__smaken" }, smaken.map(function (s) { return el("li", {}, [s]); })) : null,
        el("div", { class: "fd-slide__balken" }, [smaakBalken(p.b.s, 6)]),
        over ? el("div", { class: "fd-slide__over" }, [
          el("h4", {}, [I.over_bier]),
          el("p", {}, [over]),
          el("a", { href: url }, [I.lees_meer + " →"]),
        ]) : null,
        el("div", { class: "fd-slide__voet" }, [
          el("strong", { class: "fd-slide__prijs" }, [prijs(v ? v.price : p.b.prijs)]),
          el("span", { class: "fd-slide__acties" }, [
            el("button", { type: "button", class: "fd-link", onclick: function () { wissel(i); } }, ["↻ " + I.wissel]),
            el("button", { type: "button", class: "fd-link fd-link--grijs", onclick: function () { weghalen(i); } }, [I.haal_eruit]),
          ]),
        ]),
      ]),
    ]);
  }

  function naarBier(i, soepel) {
    var slides = root.querySelector(".fd-slides");
    if (!slides) return;
    var n = staat.pakket.length;
    i = Math.max(0, Math.min(n - 1, i));
    staat.actief = i;
    slides.scrollTo({ left: i * slides.clientWidth, behavior: soepel ? "smooth" : "auto" });
    markeer(i);
  }
  function markeer(i) {
    var items = root.querySelectorAll(".fd-rail__item");
    items.forEach(function (x, k) { x.classList.toggle("is-actief", k === i); x.setAttribute("aria-selected", k === i ? "true" : "false"); });
    var it = items[i], rail = root.querySelector(".fd-rail");
    if (it && rail) {
      var l = it.offsetLeft - rail.clientWidth / 2 + it.clientWidth / 2;
      rail.scrollTo({ left: Math.max(0, l), behavior: "smooth" });
    }
    var l2 = root.querySelector(".fd-car__pijl--l"), r2 = root.querySelector(".fd-car__pijl--r");
    if (l2) l2.disabled = i <= 0;
    if (r2) r2.disabled = i >= staat.pakket.length - 1;
  }
  function startCarrousel() {
    var slides = root.querySelector(".fd-slides");
    if (!slides) return;
    var bezig = false;
    slides.addEventListener("scroll", function () {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(function () {
        bezig = false;
        var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        if (i !== staat.actief) { staat.actief = i; markeer(i); }
      });
    });
    naarBier(staat.actief, false);
  }

  var zweef = null, kijker = null;
  function zweefBalk() {
    if (zweef) zweef.remove();
    if (kijker) kijker.disconnect();
    zweef = null;
    var echt = root.querySelector(".fd-afreken");
    if (!echt || !("IntersectionObserver" in window)) return;
    var knop = el("button", { type: "button", class: "fd-knop", onclick: function () { allesInWagen(); } }, [I.alles_in_wagen]);
    zweef = el("div", { class: "fd-zweef", "aria-hidden": "true" }, [
      el("p", { class: "fd-totaal" }, [el("span", {}, [vul(I.resultaat_titel, { n: staat.pakket.length })]), el("strong", {}, [prijs(totaal())])]),
      knop,
    ]);
    document.body.appendChild(zweef);
    kijker = new IntersectionObserver(function (e) {
      var zichtbaar = e[0].isIntersecting || e[0].boundingClientRect.top < 0;
      zweef.classList.toggle("is-aan", !zichtbaar && staat.stap === "pakket");
    });
    kijker.observe(echt);
  }

  function afrekenBalk() {
    var som = totaal();
    var meter = null;
    if (CTX.gratis) {
      var rest = CTX.gratis - som;
      meter = el("div", { class: "fd-meter" + (rest <= 0 ? " is-gratis" : "") }, [
        el("div", { class: "fd-meter__balk" }, [el("span", { style: "width:" + Math.min(100, Math.round((som / CTX.gratis) * 100)) + "%" })]),
        el("p", { class: "fd-meter__t" }, [rest > 0 ? vul(I.nog_voor_gratis, { bedrag: euro(rest) }) : I.gratis_bereikt]),
      ]);
    }
    var knop = el("button", { type: "button", class: "fd-knop fd-knop--oranje fd-afrekenen", disabled: !staat.pakket.length, onclick: function () { allesInWagen(); } }, [I.alles_in_wagen]);
    var deel = el("button", { type: "button", class: "fd-knop fd-knop--rand", onclick: function (e) { delen(e.currentTarget); } }, [I.delen]);
    return el("div", { class: "fd-afreken" }, [
      el("p", { class: "fd-totaal" }, [el("span", {}, [I.totaal + " · " + vul(I.resultaat_titel, { n: staat.pakket.length })]), el("strong", {}, [prijs(som)])]),
      meter,
      el("div", { class: "fd-afreken__knoppen" }, [knop, deel, el("a", { class: "fd-naar-wagen", href: CTX.winkelwagen || "/cart", hidden: "" }, [I.naar_wagen])]),
    ]);
  }

  // Liever een vaste box? Het top-10-pakket van de gekozen richting(en)
  function vasteBox() {
    var lijst = (staat.modus === "richting" ? staat.richtingen : []).map(function (h) { return GROEP[h] && GROEP[h].pakket; }).filter(Boolean).slice(0, 2);
    if (!lijst.length || staat.gedeeld) return null;
    return el("div", { class: "fd-box" }, [
      el("h3", { class: "fd-box__kop" }, [I.liever_box]),
      el("div", { class: "fd-box__lijst" }, lijst.map(function (b) {
        return el("a", { class: "fd-box__item", href: b.url }, [
          b.beeld ? el("img", { src: b.beeld, alt: "", loading: "lazy", width: "96", height: "96" }) : null,
          el("span", {}, [el("b", {}, [b.titel]), el("span", {}, [I.liever_box_sub]), el("strong", {}, [prijs(b.prijs)])]),
        ]);
      })),
    ]);
  }

  // ---------- "Mail mij dit pakket" ----------
  function mailMij() {
    if (!staat.pakket.length) return null;
    var vak = el("div", { class: "fd-mailmij" });
    if (staat.gemaild) {
      vak.appendChild(el("p", { class: "fd-mailmij__klaar" }, [vul(I.mail_klaar, { email: staat.gemaild })]));
      return vak;
    }
    // Standaard open (17 okt 2026): je eigen pakket in je mail is de beste haak voor de nieuwsbrief
    function toonForm() {
      vak.innerHTML = "";
      var email = el("input", { type: "email", required: true, autocomplete: "email", placeholder: I.mail_placeholder, value: CTX.email || null, "aria-label": I.mail_placeholder });
      var vink = el("input", { type: "checkbox" });
      var status = el("p", { class: "fd-mailmij__status", role: "status" });
      var knop = el("button", { type: "submit", class: "fd-knop fd-knop--rand-paars" }, [I.mail_knop]);
      var form = el("form", { class: "fd-mailmij__form", novalidate: true }, [
        el("p", {}, [I.mail_uitleg]),
        el("div", { class: "fd-mailmij__rij" }, [email, knop]),
        el("label", { class: "fd-vinkje" }, [vink, el("span", {}, [I.mail_vink])]),
        status,
      ]);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var adres = (email.value || "").trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(adres)) { status.textContent = I.mail_ongeldig; return; }
        knop.disabled = true;
        status.textContent = "";
        stuurPakketMail(adres, vink.checked)
          .then(function () { staat.gemaild = adres; clearTimeout(updateTimer); render(); })
          .catch(function () { knop.disabled = false; status.textContent = I.mail_mislukt; });
      });
      vak.appendChild(el("h3", { class: "fd-mailmij__kop" }, [I.mail_link]));
      vak.appendChild(form);
    }
    toonForm();
    return vak;
  }
  var KLAVIYO = "https://a.klaviyo.com/client/";
  var KLAVIYO_HDR = { "Content-Type": "application/vnd.api+json", revision: "2025-07-15" };
  function stuurPakketMail(adres, nieuwsbrief) {
    var props = Object.assign({ Gemaild: true, Voor: staat.voor || "mezelf", Taal: TAAL, Bron: MODUS }, pakketEvent());
    var event = fetch(KLAVIYO + "events?company_id=V6BeY6", {
      method: "POST",
      headers: KLAVIYO_HDR,
      body: JSON.stringify({ data: { type: "event", attributes: {
        metric: { data: { type: "metric", attributes: { name: "Bierpakket Gemaild" } } },
        profile: { data: { type: "profile", attributes: { email: adres } } },
        properties: props,
      } } }),
    }).then(function (r) { if (!r.ok) throw new Error("klaviyo " + r.status); });
    var profiel = {
      Smaakrichtingen: staat.modus === "zelf" ? staat.stijlen : staat.richtingen.concat(staat.alcvrij ? ["alcoholvrij"] : []),
      "Smaakwijzer datum": new Date().toISOString().slice(0, 10),
      "Smaakwijzer taal": TAAL,
    };
    if (profielNaam()) profiel.Smaakprofiel = profielNaam();
    var abonnement = !nieuwsbrief ? Promise.resolve() : fetch(KLAVIYO + "subscriptions?company_id=V6BeY6", {
      method: "POST",
      headers: KLAVIYO_HDR,
      body: JSON.stringify({ data: { type: "subscription", attributes: {
        custom_source: MODUS === "smaakwijzer" ? "Smaakwijzer" : "Bierpakket samenstellen",
        profile: { data: { type: "profile", attributes: { email: adres, properties: profiel } } },
      }, relationships: { list: { data: { type: "list", id: "Vp7gd9" } } } } }),
    }).catch(function () {});
    // Nieuwe inschrijving: welkomstmail op smaakrichting (flow op "Smaakwijzer Aangemeld", sjabloon sw-welkom, NL/EN/DE)
    var welkom = !nieuwsbrief ? Promise.resolve() : abonnement.then(function () { return welkomEvent(); }).then(function (props) {
      return fetch(KLAVIYO + "events?company_id=V6BeY6", {
        method: "POST",
        headers: KLAVIYO_HDR,
        body: JSON.stringify({ data: { type: "event", attributes: {
          metric: { data: { type: "metric", attributes: { name: "Smaakwijzer Aangemeld" } } },
          profile: { data: { type: "profile", attributes: { email: adres } } },
          properties: props,
        } } }),
      });
    }).catch(function () {}); // mag mislukken zonder dat de pakketmail mislukt
    return Promise.all([event, abonnement, welkom]).then(function () {
      try { if (window.klaviyo && typeof window.klaviyo.identify === "function") window.klaviyo.identify({ email: adres }); } catch (e) {}
    });
  }

  // Wat de welkomstmail nodig heeft: gekozen richtingen (met top-10-pakket) en drie aanraders uit dezelfde hoek
  // die níet in het pakket zitten (best gewaardeerd, op voorraad, met foto)
  function absoluut(u) {
    if (!u) return "";
    if (u.slice(0, 2) === "//") return "https:" + u;
    if (u.charAt(0) === "/") return window.location.origin + u;
    return u;
  }
  function welkomEvent() {
    var inPakket = {};
    staat.pakket.forEach(function (p) { inPakket[p.b.h] = 1; });
    // zelfde prijsniveau als gekozen bij 'hoe ver wil je gaan' (anders zijn de hoogste Untappd-scores allemaal €12+)
    var band = staat.soort === "toegankelijk" ? { max: 450 } : staat.soort === "parels" ? { min: 450, max: 1500, minAbv: staat.alcvrij ? 0 : 60 } : { max: 800 };
    var kandidaten = BIEREN.filter(function (x) { return !inPakket[x.h] && x.r > 0 && magErin(x, band); })
      .sort(function (a, b) { return score10(b) - score10(a); })
      .slice(0, 12);
    return Promise.all(kandidaten.map(function (x) { return haalProduct(x.h); })).then(function (prods) {
      var aanraders = [], brs = {};
      prods.forEach(function (prod, i) {
        if (aanraders.length >= 3 || !prod || !prod.featured_image || !variant(prod)) return;
        var x = kandidaten[i];
        if (x.br && brs[x.br]) return; // drie verschillende brouwerijen
        brs[x.br] = 1;
        aanraders.push({
          titel: prod.title,
          url: window.location.origin + ROOT + "/products/" + x.h,
          beeld: absoluut(prod.featured_image) + (prod.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=300",
          stijl: x.us || STIJLNAAM[x.fijn] || STIJLNAAM[x.st] || "",
          score: komma(x.r.toFixed(2)),
          prijs: euro(variant(prod).price),
        });
      });
      var richtingen = staat.modus === "richting" ? staat.richtingen.map(function (h) {
        var g = GROEP[h] || {};
        return {
          naam: g.t || h,
          url: absoluut((CTX.biersoorten || ROOT + "/collections/biersoorten") + "#bs-" + h),
          pakket: g.pakket ? { titel: g.pakket.titel, url: absoluut(g.pakket.url), beeld: absoluut(g.pakket.beeld), prijs: euro(g.pakket.prijs) } : null,
        };
      }) : [];
      return {
        Smaak: smaakLabel(),
        Smaakprofiel: profielNaam(),
        Voor: staat.voor || "mezelf",
        Taal: TAAL,
        Bron: MODUS,
        Link: pakketUrl(),
        Richtingen: richtingen,
        Aanraders: aanraders,
      };
    });
  }

  // ---------- acties ----------
  function wissel(i) {
    var p = staat.pakket[i];
    p.geweigerd[p.b.h] = 1;
    var nieuw = kiesVoorPlek(i, staat.pakket, p.geweigerd, staat.pakket.length);
    if (!nieuw) {
      p.geweigerd = {};
      p.geweigerd[p.b.h] = 1;
      nieuw = kiesVoorPlek(i, staat.pakket, p.geweigerd, staat.pakket.length);
    }
    if (!nieuw) { alert(I.geen_meer); return; }
    staat.pakket[i] = { b: nieuw, vast: false, p: null, geweigerd: p.geweigerd };
    staat.actief = i;
    na();
    kl("Bierpakket Bier Gewisseld", { Weg: p.b.h, Erin: nieuw.h });
  }
  function weghalen(i) {
    staat.pakket.splice(i, 1);
    staat.actief = Math.min(i, staat.pakket.length - 1);
    na();
  }
  function bierErbij() {
    var i = staat.pakket.length;
    var b = kiesVoorPlek(i, staat.pakket, null, i + 1);
    if (!b) { alert(I.geen_meer); return; }
    staat.pakket.push({ b: b, vast: false, p: null, geweigerd: {} });
    staat.actief = staat.pakket.length - 1;
    na();
  }
  function opnieuwSamenstellen() {
    staat.vorige = {};
    staat.pakket.forEach(function (p) { if (!p.vast) staat.vorige[p.b.h] = 1; });
    staat.gedeeld = false;
    staat.vervangen = false;
    staat.pakket = stelSamen(staat.aantal || staat.pakket.length || 12);
    staat.actief = 0;
    laadProducten().then(function () {
      sorteer(staat.pakket);
      render();
      bewaarInUrl();
      meldPakketLater();
    });
  }
  function na() {
    laadProducten().then(function () {
      render();
      bewaarInUrl();
      meldPakketLater();
    });
  }

  // Toevoegen duurt even: hop-statiegeld.js laat add.js pas terugkomen als het statiegeld in de winkelwagen klopt
  // (bij 24 bieren ±3 s). Daarom meteen zichtbaar bezig, op beide knoppen, en daarna door naar de winkelwagen
  // (Tjapco 16 okt: "blijft hangen" na klikken).
  var toevoegenBezig = false;
  function allesInWagen() {
    if (toevoegenBezig) return;
    toevoegenBezig = true;
    var knoppen = [].slice.call(document.querySelectorAll(".fd-afrekenen, .fd-zweef .fd-knop"));
    knoppen.forEach(function (k) {
      k.disabled = true;
      k.classList.add("is-bezig");
      k.innerHTML = "";
      k.appendChild(el("span", { class: "fd-knop__spin", "aria-hidden": "true" }));
      k.appendChild(document.createTextNode(I.even_geduld));
    });
    var items = staat.pakket
      .map(function (p) {
        var v = variant(p.p);
        return v ? { id: v.id, quantity: 1, properties: { _bierpakket: staat.id || "BP" } } : null;
      })
      .filter(Boolean);
    var naarWagen = function () { window.location.href = CTX.winkelwagen || ROOT + "/cart"; };
    var vangnet = setTimeout(naarWagen, 12000); // reageert de winkelwagen niet, dan staan de bieren er vrijwel zeker al in
    fetch(ROOT + "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add");
        clearTimeout(updateTimer);
        clearTimeout(vangnet);
        knoppen.forEach(function (k) { k.classList.remove("is-bezig"); k.classList.add("is-toegevoegd"); k.textContent = I.toegevoegd; });
        kl("Bierpakket In Winkelwagen", { Totaal: totaal() / 100, Bieren: staat.pakket.map(function (p) { return p.b.h; }), Gedeeld: staat.gedeeld, Pakket: staat.id });
        setTimeout(naarWagen, 350); // even het vinkje laten zien
      })
      .catch(function () {
        clearTimeout(vangnet);
        toevoegenBezig = false;
        knoppen.forEach(function (k) { k.disabled = false; k.classList.remove("is-bezig"); k.textContent = I.alles_in_wagen; });
        alert(I.toevoegen_mislukt);
      });
  }

  function delen(knop) {
    var url = pakketUrl();
    kl("Bierpakket Gedeeld");
    if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      navigator.share({ title: MODUS === "smaakwijzer" ? I.titel_sw : I.titel_bp, url: url }).catch(function () {});
      return;
    }
    var klaar = function () {
      var oud = knop.textContent;
      knop.textContent = "✓ " + I.gekopieerd;
      setTimeout(function () { knop.textContent = oud; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(klaar, function () { window.prompt(I.delen, url); });
    else window.prompt(I.delen, url);
  }

  // ---------- start ----------
  if (leesUitUrl()) {
    laadScherm();
    laadProducten().then(function () {
      render();
      kl("Bierpakket Geopend", { Gedeeld: true });
    });
  } else {
    var q = new URLSearchParams(window.location.search);
    var richting = (q.get("richting") || "").split(/[ +,]/).filter(function (h) { return GROEP[h]; });
    var smaak = q.get("smaak");
    if (richting.length || PROFIEL_NAAR[smaak]) {
      // doorgestuurd met een richting (Biersoorten, oude Smaakwijzer-links): die staat al aan
      staat.voor = q.get("voor") === "cadeau" ? "cadeau" : q.get("voor") === "samen" ? "samen" : null;
      staat.richtingen = richting.length ? richting : PROFIEL_NAAR[smaak].slice();
      staat.alcvrij = smaak === "zonder-alcohol";
      staat.modus = staat.richtingen.length ? "richting" : "mix";
      if (staat.voor) { gestart = true; kl("Bierpakket Gestart", { Bron: MODUS + "-link" }); staat.stap = "richting"; }
    }
    render();
  }
})();
